import { AirplaneTilt } from "@phosphor-icons/react";

export const isAutopilotExpense = (exp) => exp?.auto_approve_reason === "autopilot";

export const AutopilotBadge = ({ exp, testId }) => {
  if (!isAutopilotExpense(exp)) return null;
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm bg-sky-600 text-white text-[9px] uppercase tracking-[0.15em] font-bold shadow-sm flex-shrink-0"
      title="Coded, approved and pushed automatically by an Autopilot rule"
      data-testid={testId || `autopilot-badge-${exp.id}`}
    >
      <AirplaneTilt size={9} weight="bold" /> Autopilot
    </span>
  );
};
